<template>
    <div class="custom-input">
        <input type="text" autocomplete="off" :value="value" ref="input" @input="inputHandle" :maxlength="maxlength">
        <span class="count">{{ count }}</span>
    </div>
</template>

<script>
import CustomInput from './CustomInput.js'
export default CustomInput
</script>

<style lang="scss" scoped>
@import "./CustomInput.scss";
</style>


// WEBPACK FOOTER //
// src/components/CustomInput/CustomInput.vue